
"use strict"; // jshint ignore:line

import {
	Group,
	Vector3,
	Face3,
	Geometry,
	MeshBasicMaterial,
	Mesh,
	Shape,
	ShapeGeometry,
	DoubleSide
} from '../../../src/js/three.module.js';

export default function PaintingTool( opts ){
	Group.call( this );

	this.enabled = false;
	this.settings = opts.settings || {};
	this.settings.color = this.settings.color || 0xff0000;
	this.planes = {};
}

PaintingTool.prototype = Object.create( Group.prototype );

PaintingTool.prototype.start = function( plane ){
	this.enabled = true;

	this.selected_plane = plane || null;

	for (var uuid in this.planes) {
		this.planes[uuid].setSelection( this.selected_plane == this.planes[uuid] )
	}
};
PaintingTool.prototype.stop = function(){
	this.enabled = false;
	this.selected_plane = null;
};
PaintingTool.prototype.createPlane = function( normal, point, vertices ){
	var plane = new PaintingTool.Plane( normal, point, vertices );
	this.planes[ plane.mesh.uuid ] = plane;
	this.add( plane.mesh );
	return plane;
}
PaintingTool.Plane = function( normal, point, vertices ){
	this.normal = point;
	this.point  = point;

	var geometry = new Geometry();
	var material = new MeshBasicMaterial({ color: 0xFFFFFF, side: DoubleSide, depthTest: true, depthWrite: true });

	for( var idx in vertices ){
		geometry.vertices.push( vertices[ idx ]);
	}
	geometry.faces.push(new Face3( 0, 1, 2 ));

	this.mesh = new Mesh( geometry, material );
	this.mesh.frustumCulled = false;
};
PaintingTool.Plane.setSelection = function( selected ){
	if( this.selected = !!selected ){

	} else {

	}
}


export function DragPlane( handles ) {
	this.handles = handles;
	this.center  = new Vector3();
	this.refresh();
}

DragPlane.prototype.refresh = function(){
	this.center.set( 0, 0, 0 );
	for( var i in this.handles ){
		this.center.x += this.handles[i].position.x;
		this.center.y += this.handles[i].position.y;
		this.center.z += this.handles[i].position.z;
	}
	this.center.x /= this.handles.length;
	this.center.y /= this.handles.length;
	this.center.z /= this.handles.length;
}
DragPlane.generate = function( n, circumradius ){

    var shape = new Shape(),
        vertices = [],
        x;

    // Calculate the vertices of the n-gon.                 
    for (x = 1; x <= n; x++) {
        vertices.push([
            circumradius * Math.sin((Math.PI / n) + (x * ((2 * Math.PI)/ n))),
            circumradius * Math.cos((Math.PI / n) + (x * ((2 * Math.PI)/ n)))
        ]);
    }

    // Start at the last vertex.                
    shape.moveTo.apply(shape, vertices[ n - 1 ]);

    // Connect each vertex to the next in sequential order.
    for (x = 0; x < n; x++) {
        shape.lineTo.apply(shape, vertices[x]);
    }

    // It's shape and bake... and I helped!         
    return new ShapeGeometry(shape);
}

